import React, { useState, useEffect } from 'react';
import { Card, Button, Container, Row, Col } from 'react-bootstrap';
import SetProfileModal from '../components/FormModals/SetProfileModal.tsx';
import MemberSearch from '../components/MemberSearch.tsx'; // Import the MemberSearch component
import { useAccount, useReadContract } from 'wagmi';
import memberInfoContract from '../contracts/tgetherMembersInfo.json';

const memberInfoAddress = process.env.REACT_APP_MEMBERS_INFO_CONTRACT_ADDRESS;

interface MemberInfo {
  _name: string;
  _description: string;
  _degrees: string;
  _awards: string;
  _endpoint: string;
}

function Profile() {
    const { address, isConnected } = useAccount();  // Wagmi hook to get connected account
    const [memberInfo, setMemberInfo] = useState<MemberInfo | null>(null);
    const [showModal, setShowModal] = useState(false);

    // Fetch member info if the user is connected
    const { data: memberData, isSuccess: memberSuccess } = useReadContract({
        address: isConnected ? (memberInfoAddress as `0x${string}`) : undefined,
        abi: memberInfoContract.abi,
        functionName: 'getMemberInfo',
        args: [address as `0x${string}`],
    });

    // Update member info once the contract read is successful
    useEffect(() => {
        if (memberSuccess && memberData) {
            const [_name, _description, _degrees, _awards, _endpoint] = memberData as [string, string, string[], string[], string];
            setMemberInfo({
                _name: _name || "Not Set",
                _description: _description || "No description provided",
                _degrees: _degrees.length > 0 ? _degrees.join(', ') : "No degrees listed",
                _awards: _awards.length > 0 ? _awards.join(', ') : "No awards listed",
                _endpoint: _endpoint || "No endpoint provided",
            });
        }
    }, [memberSuccess, memberData]);

    return (
        <Container className="mt-5">
            <Row className="mb-4">
                <Col md={6} className="mx-auto">
                    <Card className="mb-4 shadow-sm">
                        <Card.Body>
                            {memberInfo ? (
                                <>
                                    <Card.Title className="mb-3">{memberInfo._name}</Card.Title>
                                    <Card.Text><strong>Description:</strong> {memberInfo._description}</Card.Text>
                                    <Card.Text><strong>Degrees:</strong> {memberInfo._degrees}</Card.Text>
                                    <Card.Text><strong>Awards:</strong> {memberInfo._awards}</Card.Text>
                                    <Card.Text>
                                        <strong>Endpoint:</strong> 
                                        {memberInfo._endpoint.startsWith("http") ? (
                                            <a href={memberInfo._endpoint} target="_blank" rel="noopener noreferrer">
                                                {memberInfo._endpoint}
                                            </a>
                                        ) : (
                                            memberInfo._endpoint
                                        )}
                                    </Card.Text>
                                </>
                            ) : (
                                <p>Loading member information...</p>
                            )}
                        </Card.Body>
                        <Card.Footer className="text-right">
                            <Button variant="primary" onClick={() => setShowModal(true)}>
                                Set Profile Information
                            </Button>
                        </Card.Footer>
                    </Card>
                </Col>
            </Row>

            {/* Render the MemberSearch component */}
            <Row>
                <Col md={6} className="mx-auto">
                    {isConnected && address && (
                        <MemberSearch value={address as `0x${string}`} />
                    )}
                </Col>
            </Row>

            <SetProfileModal show={showModal} setShow={setShowModal} />
        </Container>
    );
}

export default Profile;
